import { render, staticRenderFns } from "./IconTpms.vue?vue&type=template&id=349e3f38"
import script from "./IconTpms.vue?vue&type=script&lang=js"
export * from "./IconTpms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports